import React from 'react';
import Label from '../../../Label/Label';
import Text from '../../../Text';
import styles from './TopFieldContent.module.scss';

interface TopFieldContentProps {
	label?: string;
	isRequired?: boolean;
	hideRequired?: boolean;
	labelStyle?: object;
}

const TopFieldContent = ({
	label,
	isRequired,
	hideRequired,
	labelStyle,
}: TopFieldContentProps) => (
	<div className={styles.topContent}>
		{label && <Label tx={label} style={labelStyle} firstUpper />}
		{!isRequired && !hideRequired && (
			<Text className={styles.required} tx={'base.notRequired'} />
		)}
	</div>
);

export default TopFieldContent;
